import BrandLogo from '@brands/Components/BrandLogo/BrandLogo';
import logo from '@brands/Components/PatientIntakeNavigation/Icons/patientIntakeNavigationLogo.svg';
import LinearProgressDisplay from '@brands/Components/ProgressDisplay/ProgressDisplay';
import { config } from '@brands/config/config';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { selectClientBranding } from '@brands/store/selectors/clientBranding';
import { selectOrganization } from '@brands/store/selectors/organization';
import React, { useState } from 'react';

import closeIcon from './Icons/patientIntakeNavigationClose.svg';
import AbandonIntakeProcessModal from './Modal/AbandonIntakeProcessModal';
import styles from './styles.module.scss';

interface PatientIntakeNavigationProps {
  progress: number;
}

const PatientIntakeNavigation: React.FC<PatientIntakeNavigationProps> = ({ progress }) => {
  const { currentOrganization } = useAppSelector(selectOrganization);
  const clientBranding = useAppSelector(selectClientBranding);
  const [displayAbandonIntakeProcessModal, setDisplayAbandonIntakeProcessModal] = useState(false);

  const getOrgColor = (orgId: string): string => {
    switch (orgId) {
      case 'dentistry-one':
        return '#1ba1e0';
      case 'gum-virtual-care':
        return '#009257';
      default:
        return '#1ba1e0';
    }
  };

  const orgColor = clientBranding?.primary_color || getOrgColor(config.organization_id);

  return (
    <>
      <div className={styles.PatientIntakeNavigationDiv}>
        <div className={styles.PatientIntakeNavigationDivFirst}>
          <span
            className={`${styles.logo} ${
              (clientBranding?.uses_custom_logo ?? currentOrganization?.uses_custom_logo)
                ? styles.poweredByTextParent
                : undefined
            }`}
          >
            <BrandLogo
              customLogoUrl={clientBranding?.logo_url}
              fallbackLogo={logo}
              className={styles.PatientIntakeNavigationDivFirstLogo}
              onClick={() => setDisplayAbandonIntakeProcessModal(true)}
            />
            {(clientBranding?.uses_custom_logo ?? currentOrganization?.uses_custom_logo) && (
              <span className={styles.poweredByText}>Powered by Dentistry.One</span>
            )}
          </span>
          <div onClick={() => setDisplayAbandonIntakeProcessModal(true)} style={{ cursor: 'pointer' }}>
            <img src={closeIcon} className={styles.PatientIntakeNavigationDivFirstClose} alt="Close" />
          </div>
        </div>
        <LinearProgressDisplay progress={progress} color={orgColor} />
      </div>
      {displayAbandonIntakeProcessModal && (
        <AbandonIntakeProcessModal setDisplayAbandonIntakeProcessModal={setDisplayAbandonIntakeProcessModal} />
      )}
    </>
  );
};

export default PatientIntakeNavigation;
